export const fetchAccessToken = async (getAccessTokenSilently) => {
  try {
    const token = await getAccessTokenSilently();
    return token;
  } catch (err) {
    console.error("Error fetching access token:", err);
    throw err;
  }
};

export const getRowClassName = (rows) => (rowData, rowIndex) => {
  const idx = typeof rowIndex === 'number' ? rowIndex : rows.indexOf(rowData);
  return idx % 2 === 0 ? 'even-row' : 'odd-row';
};

export const apiCallErrorHandler = async (response, defaultMessage = 'API call failed') => {
  try {
      const errorData = await response.json();
      const message = errorData?.message || null;
      const details = errorData?.details || null;

      console.warn(message, details);

      // Prefer the specific exception details over the generic wrapper message
      throw new Error(details || message || defaultMessage);
  } catch (e) {
      if (e instanceof SyntaxError) {
          // Response was not JSON
          throw new Error(defaultMessage);
      }
      throw e;
  }
}